import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { ConsoleLoggerService } from '../../../core/services/console-logger.service';
import { User } from '@angular/fire/auth';
import { nav_path } from 'src/app/app-routing.module';
import { of } from 'rxjs';
import { companyInformation } from '../../../companyinformation';
import { UpdateProfileResponse } from '../../../shared/interfaces/functions-response';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'anon-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  public readonly companyInformation = companyInformation;
  editing = false;
  nav_path = nav_path;
  user: User | null = this.auth.user;
  userDisplayName: string | null | undefined = this.auth.user?.displayName;
  deleteButtonPushed = false;
  nameLoading = false;
  private title = "Profile page";

  constructor(
    private router: Router,
    public auth: AuthService,
    private cLog: ConsoleLoggerService,
    private seo: SeoService
  ) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.profile
    });
  }

  edit() { this.editing = true; }
  cancelEdit() { this.editing = false; this.userDisplayName = this.user?.displayName!; }

  updateUser() {
    if (this.userDisplayName == this.user?.displayName) { this.cancelEdit() }
    else {
      this.nameLoading = true;
      this.auth.updateUser({ displayName: this.userDisplayName })
        .then((res: UpdateProfileResponse) => {
          if (res.ok && res.user) {
            this.auth.user$ = of(res.user);
            this.auth.user = res.user;
            this.user = res.user;
          }
          this.cLog.log(res.message);
          this.nameLoading = this.editing = false;
        })
    }
  }

  delete() { this.auth.delete(this.user!).then(() => { this.router.navigate([nav_path.home]); }); }

}
